export interface ProductionStep {
  readonly title: string;
  readonly description: string;
}

/** 제작 과정 여섯 단계 — 모든 상품에 같은 고정 문구(클라이언트 제공, 2026-10-19). 번호는 순서로 매긴다. */
export const PRODUCTION_STEPS: readonly ProductionStep[] = [
  { title: '상품 고르기', description: '만들고 싶은 굿즈와 조건을 확인' },
  { title: '디자인 넣기', description: '수량·색상·인쇄 방식을 고르고 로고 적용' },
  { title: '견적 확인', description: '선택한 조건으로 예상 비용을 바로 계산' },
  { title: '상담 요청', description: '디자인과 견적을 담당자에게 그대로 전달' },
  { title: '최종 견적', description: '담당자가 확인 후 최종 금액 안내' },
  { title: '제작 · 배송', description: '제작 후 원하는 곳으로 배송' },
];
